var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-popconfirm',_vm._g(_vm._b({attrs:{"title":"确定删除？"}},'el-popconfirm',_vm.$attrs,false),_vm.$listeners),[_c('el-button',{attrs:{"slot":"reference","type":"text"},slot:"reference"},[_c('i',{staticClass:"el-icon-delete delete"})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-d5fd5260","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/button/src/delete.vue
// module id = 180
// module chunks = 0